<template>
<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.774777 1.48963H12.2252C13.2583 1.51642 13.2583 -0.0264405 12.2252 0.00034618H0.774777C-0.258259 -0.026494 -0.258259 1.51642 0.774777 1.48963Z" fill="#B5C6D8"/>
<path d="M12.2252 5.25534H0.774777C-0.258259 5.22855 -0.258259 6.77141 0.774777 6.74463H12.2252C13.2583 6.77141 13.2583 5.22855 12.2252 5.25534Z" fill="#B5C6D8"/>
<path d="M12.2252 10.4839H0.774777C-0.258259 10.4839 -0.258259 12 0.774777 12H12.2252C13.2583 12 13.2583 10.4839 12.2252 10.4839Z" fill="#B5C6D8"/>
</svg>
</template>
